// src/components/DietPlanSection.js

import React from 'react';

// Utility function to normalize the date for comparison
const getFormattedDate = (date) => {
    // Ensure input is a valid Date object before calling methods
    if (date instanceof Date && !isNaN(date)) {
        return date.toISOString().split('T')[0];
    }
    return null; 
};

// Component to display the diet plan details and weekly table
const DietPlanSection = ({ dietPlanData, mealTimings }) => {
    
    // Fallback if data hasn't loaded or is empty
    if (!dietPlanData || !dietPlanData.weeklyDietPlan) {
        return <div className="card full-width loading-card">Loading Diet Plan...</div>;
    }

    const todayNormalized = getFormattedDate(new Date());

    return (
        <div className="card full-width diet-plan-section">
            <h2>🥗 Current Diet Plan: {dietPlanData.name}</h2>
            
            {/* Display plan summary */}
            <p className="plan-dates">
                🗓️ Active: {new Date(dietPlanData.startDate).toLocaleDateString()} to {new Date(dietPlanData.endDate).toLocaleDateString()}
            </p>
            <p className="plan-notes">
                📝 Notes: {dietPlanData.notes || 'None provided.'}
            </p>
            
            {/* Weekly Meals Grid Table */}
            <div className="weekly-meals-grid">
                <table className="meals-table">
                    <thead>
                        <tr>
                            <th>Day/Date</th>
                            {/* Use mealTimings for column headers */}
                            {mealTimings.map((timing, index) => (
                                <th key={index}>{timing}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {dietPlanData.weeklyDietPlan.map((dayPlan, index) => {
                            const rowDateNormalized = getFormattedDate(new Date(dayPlan.date));
                            // Highlight the row if the date matches today
                            const isToday = rowDateNormalized === todayNormalized;

                            return (
                                <tr key={index} className={isToday ? 'highlight-today' : ''}>
                                    {/* Display the date and day name */}
                                    <td>
                                        {dayPlan.date ? new Date(dayPlan.date).toLocaleDateString(undefined, { weekday: 'short', month: 'numeric', day: 'numeric' }) : `Day ${index + 1}`}
                                    </td>
                                    {/* Map through all meals (8 columns) */}
                                    {Array.from({ length: 8 }).map((_, mealIndex) => (
                                        <td key={mealIndex}>{dayPlan.meals[mealIndex] || ''}</td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <p className="uploaded-at">
                Last Updated: {new Date(dietPlanData.lastModified.toDate ? dietPlanData.lastModified.toDate() : dietPlanData.lastModified).toLocaleString()}
            </p>
        </div>
    );
};

export default DietPlanSection;